<template>
  <main class="main cus_view_estimationform" role="main">
    <div class="main_con">
      <div class="request_top" id="detailView" @click="showDetailView">
        <img
          :src="require('@/assets/front/images/new/img_txt_phone_jalnan.svg')"
          alt=""
        />
        <!-- <img
          :src="require('@/assets/front/images/new/ar_hash_down.svg')"
          alt=""
        /> -->
        <span></span>
      </div>
      <div class="w_cont">
        <ul>
          <li>
            <img src="@/assets/front/images/manual/img_way_01.png" />
            <div class="step"><p>STEP 1</p></div>
            <div class="txt">
              <p>
                요청서를 작성하여 구매를 희망하는 휴대폰을 등록해 주세요.<br />
                <span>(홈 '휴대폰 상담 시작하기' 이용)</span>
              </p>
            </div>
          </li>
          <li>
            <img src="@/assets/front/images/manual/img_way_02.png" />
            <div class="step"><p>STEP 2</p></div>
            <div class="txt">
              <p>
                우리 동네 매장들에게 작성한 요청서를 보내 주세요.<br />
                <span>(요청서 없이 바로 상담도 가능)</span>
              </p>
            </div>
          </li>
          <li>
            <img src="@/assets/front/images/manual/img_way_03.png" />
            <div class="step"><p>STEP 3</p></div>
            <div class="txt">
              <p>전송 후에는 채팅방이 개설되며 견적과 상담이 진행됩니다.</p>
            </div>
          </li>
          <li>
            <img src="@/assets/front/images/manual/img_way_04.png" />
            <div class="step"><p>STEP 4</p></div>
            <div class="txt">
              <p>
                여러 매장에게 견적을 받아서, 요금과 혜택을 비교해보세요!
              </p>
            </div>
          </li>
          <li>
            <img src="@/assets/front/images/manual/img_way_05.png" />
            <div class="step"><p>STEP 5</p></div>
            <div class="txt">
              <p>
                가장 합리적인 견적을 보낸 매장과 방문(개통)약속을 잡아보세요!
              </p>
            </div>
          </li>
          <!-- <li>
            <img src="@/assets/front/images/manual/img_way_06.png" />
            <div class="step"><p>STEP 6</p></div>
            <div class="txt">
              <p>
                네이버 밴드 가입 혹은 카카오 채팅을 유도하거나 매장에 방문해야
                가격을 알려준다는 매장들은 가급적 주의하시길 바랍니다!
              </p>
            </div>
          </li> -->
        </ul>
      </div>

      <div class="request_write">
        <div class="request_table" v-if="estimationModel.steps > 1">
          <dl v-show="estimationModel.steps > 1">
            <dt>구매 대상</dt>
            <dd>
              {{ concatTargetName }}
            </dd>
          </dl>
          <dl v-show="estimationModel.steps > 4">
            <dt>현재 이용 내역</dt>
            <dd>{{ concatTelecomAndDeviceName }}</dd>
          </dl>
          <dl v-show="estimationModel.steps > 6">
            <dt>단말기</dt>
            <dd>{{ estimationModel.needModelName }}</dd>
          </dl>
          <dl v-show="estimationModel.steps > 7">
            <dt>통신사 변경 의향</dt>
            <dd>{{ telecomMaintanceName }}</dd>
          </dl>
          <dl v-show="estimationModel.steps > 8">
            <dt>월 납부액</dt>
            <dd>{{ dataUsageName }}</dd>
          </dl>
        </div>

        <div v-show="estimationModel.steps === 1" class="chat_box">
          <div class="prof seller">
            <div class="inner">
              <img
                :src="
                  require('@/assets/front/images/v2/profiles/img_perce_prof_w.png')
                "
                alt=""
              />
            </div>
          </div>
          <div class="chat_con">
            <div class="chat_txt">
              어느 분의 휴대폰을 구매하고자 하시나요?
            </div>
            <div>
              <div class="radio">
                <label
                  ><input
                    type="radio"
                    v-model="estimationTarget"
                    name="rq_01"
                    :value="{
                      name: '본인',
                      value: 1,
                    }"
                  /><span>본인</span></label
                >
              </div>
              <div class="radio">
                <label
                  ><input
                    type="radio"
                    v-model="estimationTarget"
                    name="rq_01"
                    :value="{
                      name: '부/모',
                      value: 2,
                    }"
                  />
                  <span>부/모</span></label
                >
              </div>
              <div class="radio">
                <label
                  ><input
                    type="radio"
                    v-model="estimationTarget"
                    name="rq_01"
                    :value="{
                      name: '배우자',
                      value: 3,
                    }"
                  /><span>배우자</span></label
                >
              </div>
              <div class="radio">
                <label
                  ><input
                    type="radio"
                    v-model="estimationTarget"
                    name="rq_01"
                    :value="{
                      name: '자녀',
                      value: 4,
                    }"
                  /><span>자녀</span></label
                >
              </div>
            </div>
          </div>
        </div>
        <div v-show="estimationModel.steps === 2" class="chat_box">
          <div class="prof seller">
            <div class="inner">
              <img
                :src="
                  require('@/assets/front/images/v2/profiles/img_perce_prof_w.png')
                "
                alt=""
              />
            </div>
          </div>
          <div class="chat_con">
            <div class="chat_txt">자녀분의 연령대는 어떻게 되나요?</div>
            <div>
              <div class="radio">
                <label
                  ><input
                    type="radio"
                    v-model="estimationTargetAge"
                    :value="{
                      name: '만 18세 이하',
                      value: 2,
                    }"
                    name="rq_01_01"
                  />
                  <span>만 18세 이하<br />(2021년 기준 07년생 생일 이전)</span>
                </label>
              </div>
              <div class="radio">
                <label
                  ><input
                    type="radio"
                    v-model="estimationTargetAge"
                    :value="{
                      name: '만 12세 이하',
                      value: 3,
                    }"
                    name="rq_01_01"
                  />
                  <span>만 12세 이하<br />(2021년 기준 07년생 생일 이전)</span>
                </label>
              </div>
              <div class="radio">
                <label
                  ><input
                    type="radio"
                    v-model="estimationTargetAge"
                    :value="{
                      name: '잘 모르겠음',
                      value: 4,
                    }"
                    name="rq_01_01"
                  />
                  <span>잘 모르겠음</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div v-show="estimationModel.steps === 3" class="chat_box">
          <div class="prof seller">
            <div class="inner">
              <img
                :src="
                  require('@/assets/front/images/v2/profiles/img_perce_prof_w.png')
                "
                alt=""
              />
            </div>
          </div>
          <div class="chat_con">
            <div class="chat_txt">
              지금 사용하시는 휴대폰에서 확인되는 정보입니다. 맞을까요?<br /><br />
              <span class="primary_dark_color small"
                >통신사: {{ myTelecomName }} / 모델명: {{ myDeviceName }}
              </span>
            </div>
            <div>
              <div class="radio">
                <label
                  ><input
                    type="radio"
                    name="rq_02"
                    v-model="isCorrectRegisteredPhone"
                    value="true"
                  /><span>예</span></label
                >
              </div>
              <div class="radio">
                <label
                  ><input
                    type="radio"
                    name="rq_02"
                    v-model="isCorrectRegisteredPhone"
                    value="false"
                  /><span>아니오</span></label
                >
              </div>
            </div>
          </div>
        </div>
        <div v-show="estimationModel.steps === 4" class="chat_box">
          <div class="prof seller">
            <div class="inner">
              <img
                :src="
                  require('@/assets/front/images/v2/profiles/img_perce_prof_w.png')
                "
                alt=""
              />
            </div>
          </div>
          <div class="chat_con">
            <div class="chat_txt">현재 사용 중인 통신사를 선택해 주세요.</div>
            <div
              class="radio"
              v-for="(item, index) in telecomList.content"
              v-bind:key="index"
            >
              <label
                ><input
                  type="radio"
                  name="rq_03"
                  :value="item.telecom_id"
                  :checked="index === 0"
                  v-model="estimationModel.telecomId"
                /><span>{{ item.telecom_name }}</span></label
              >
            </div>
          </div>
        </div>
        <div v-show="estimationModel.steps === 5" class="chat_box">
          <div class="prof seller">
            <div class="inner">
              <img
                :src="
                  require('@/assets/front/images/v2/profiles/img_perce_prof_w.png')
                "
                alt=""
              />
            </div>
          </div>
          <div class="chat_con">
            <div class="chat_txt">현재 사용 중인 휴대폰을 선택해 주세요.</div>
            <button class="btn bo" @click="gotoDeviceList">
              모델 선택하기
            </button>
            <div>
              <div class="radio">
                <label
                  ><input
                    type="radio"
                    name="rq_04"
                    v-model="estimationModel.currentModelName"
                    value="잘 모르겠음"
                  /><span>잘 모르겠음</span></label
                >
              </div>
            </div>
          </div>
        </div>
        <div v-show="estimationModel.steps === 6" class="chat_box">
          <div class="prof seller">
            <div class="inner">
              <img
                :src="
                  require('@/assets/front/images/v2/profiles/img_perce_prof_w.png')
                "
                alt=""
              />
            </div>
          </div>
          <div class="chat_con">
            <div class="chat_txt">변경하고 싶은 휴대폰은 무엇인가요?</div>
            <button class="btn bo" @click="gotoDeviceList">
              모델 선택하기
            </button>
            <div>
              <div class="radio" v-if="estimationModel.needDeviceIdx">
                <label
                  ><input
                    type="radio"
                    name="rq_05"
                    v-model="estimationModel.needModelName"
                    :value="needModelName"
                  /><span>{{ needModelName }}</span></label
                >
              </div>
              <div class="radio">
                <label
                  ><input
                    type="radio"
                    name="rq_05"
                    checked
                    v-model="estimationModel.needModelName"
                    value="최신폰 중에 혜택이 좋은 것으로 추천해 주세요"
                  /><span
                    >최신폰 중에 혜택이 좋은 것으로 추천해 주세요</span
                  ></label
                >
              </div>
              <div class="radio">
                <label
                  ><input
                    type="radio"
                    name="rq_05"
                    v-model="estimationModel.needModelName"
                    value="기종에 상관없이 가장 혜택이 좋은 휴대폰으로 추천해
                    주세요"
                  /><span
                    >기종에 상관없이 가장 혜택이 좋은 휴대폰으로 추천해
                    주세요</span
                  ></label
                >
              </div>
              <div class="radio">
                <label
                  ><input
                    type="radio"
                    name="rq_05"
                    v-model="estimationModel.needModelName"
                    value="잘 모르겠음"
                  /><span>잘 모르겠음</span></label
                >
              </div>
            </div>
          </div>
        </div>
        <div v-show="estimationModel.steps === 7" class="chat_box">
          <div class="prof seller">
            <div class="inner">
              <img
                :src="
                  require('@/assets/front/images/v2/profiles/img_perce_prof_w.png')
                "
                alt=""
              />
            </div>
          </div>
          <div class="chat_con">
            <div class="chat_txt">
              현재 사용 중인 통신사를 변경할 의향이 있을까요?
            </div>
            <div>
              <div class="radio">
                <label
                  ><input
                    type="radio"
                    name="rq_06"
                    v-model="estimationTelecomMaintance"
                    :value="{
                      name: '예',
                      value: 1,
                    }"
                  /><span>예</span></label
                >
              </div>
              <div class="radio">
                <label
                  ><input
                    type="radio"
                    name="rq_06"
                    v-model="estimationTelecomMaintance"
                    :value="{
                      name: '아니오',
                      value: 2,
                    }"
                  /><span>아니오</span></label
                >
              </div>
              <div class="radio">
                <label
                  ><input
                    type="radio"
                    name="rq_06"
                    v-model="estimationTelecomMaintance"
                    :value="{
                      name: '잘 모르겠음',
                      value: 3,
                    }"
                  /><span>잘 모르겠음</span></label
                >
              </div>
            </div>
          </div>
        </div>
        <div v-show="estimationModel.steps === 8" class="chat_box">
          <div class="prof seller">
            <div class="inner">
              <img
                :src="
                  require('@/assets/front/images/v2/profiles/img_perce_prof_w.png')
                "
                alt=""
              />
            </div>
          </div>
          <div class="chat_con">
            <div class="chat_txt">
              현재, 얼마 정도의 요금을 납부중이신가요? (월 기준)
            </div>
            <div>
              <div class="radio">
                <label
                  ><input
                    type="radio"
                    name="rq_07"
                    v-model="estimationDataUsage"
                    :value="{
                      name: '6만 원 이상',
                      value: 1,
                    }"
                  />
                  <span>
                    6만 원 이상
                  </span>
                </label>
              </div>
              <div class="radio">
                <label>
                  <input
                    type="radio"
                    name="rq_07"
                    v-model="estimationDataUsage"
                    :value="{
                      name: '4~5만 원대',
                      value: 2,
                    }"
                  />
                  <span>
                    4~5만 원대
                  </span>
                </label>
              </div>
              <div class="radio">
                <label
                  ><input
                    type="radio"
                    name="rq_07"
                    v-model="estimationDataUsage"
                    :value="{
                      name: '3만 원대',
                      value: 3,
                    }"
                  />
                  <span>
                    3만 원대
                  </span>
                </label>
              </div>
              <div class="radio">
                <label
                  ><input
                    type="radio"
                    name="rq_07"
                    v-model="estimationDataUsage"
                    :value="{
                      name: '3만 원 미만',
                      value: 4,
                    }"
                  />
                  <span>
                    3만 원 미만
                  </span>
                </label>
              </div>
              <div class="radio">
                <label
                  ><input
                    type="radio"
                    name="rq_07"
                    v-model="estimationDataUsage"
                    :value="{ name: '잘 모르겠음', value: 5 }"
                  /><span>잘 모르겠음</span></label
                >
              </div>
            </div>
          </div>
        </div>
        <div v-show="estimationModel.steps === 9" class="chat_box">
          <div class="prof seller">
            <div class="inner">
              <img
                :src="
                  require('@/assets/front/images/v2/profiles/img_perce_prof_w.png')
                "
                alt=""
              />
            </div>
          </div>
          <div class="chat_con">
            <div class="chat_txt">
              초고속 인터넷(또는 케이블 TV)을 이용 중인가요?
            </div>
            <div>
              <div class="radio">
                <label
                  ><input
                    type="radio"
                    name="rq_08"
                    v-model="estimationModelInternetUsage"
                    :value="{ name: 'SKT 인터넷 (SKB)', value: 1 }"
                  /><span>SKT 인터넷 (SKB)</span></label
                >
              </div>
              <div class="radio">
                <label
                  ><input
                    type="radio"
                    name="rq_08"
                    v-model="estimationModelInternetUsage"
                    :value="{ name: 'KT 인터넷', value: 2 }"
                  /><span>KT 인터넷</span></label
                >
              </div>
              <div class="radio">
                <label
                  ><input
                    type="radio"
                    name="rq_08"
                    v-model="estimationModelInternetUsage"
                    :value="{ name: 'LGU+ 인터넷', value: 3 }"
                  /><span>LGU+ 인터넷</span></label
                >
              </div>
              <div class="radio">
                <label
                  ><input
                    type="radio"
                    name="rq_08"
                    v-model="estimationModelInternetUsage"
                    :value="{ name: '지역방송', value: 4 }"
                  /><span>지역방송</span></label
                >
              </div>
              <div class="radio">
                <label
                  ><input
                    type="radio"
                    name="rq_08"
                    v-model="estimationModelInternetUsage"
                    :value="{ name: '잘 모르겠음', value: 5 }"
                  /><span>잘 모르겠음</span></label
                >
              </div>
              <div class="radio">
                <label
                  ><input
                    type="radio"
                    name="rq_08"
                    v-model="estimationModelInternetUsage"
                    :value="{ name: '이용안함', value: 6 }"
                  /><span>이용안함</span></label
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="btm_btn">
        <!-- <div class="step1_txt" v-show="estimationModel.steps === 1">
          <span>“요청서”</span>는 나의 요구사항을 매장에 쉽고 빠르게 전해주는
          쪽지입니다. 요청서를 작성하시고 매장에 보내보세요.
        </div> -->
        <div class="btn_wrap">
          <button
            class="btn bo"
            v-show="estimationModel.steps > 1"
            @click="prevStep"
          >
            이전
          </button>
          <button
            class="btn"
            v-show="estimationModel.steps !== 9"
            @click="nextStep"
          >
            다음
          </button>
          <button
            class="btn"
            v-show="estimationModel.steps === 9"
            @click="nextStep"
          >
            저장하기
          </button>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapActions as commonMapActions } from '@common/store/modules/common';
import * as commonActions from '@common/store/modules/common/types';
import { mapGetters as commonMapGetters } from '@common/store/modules/common';
import * as commonGetters from '@common/store/modules/common/getters';

import {
  mapActions as userMapActions,
  mapGetters as userMapGetters,
} from '@common/store/modules/user';
import * as userTypes from '@common/store/modules/user/types';

import {
  mapActions as estimateMapActions,
  mapGetters as estimateMapGetters,
} from '@common/store/modules/estimate';
import * as estimateTypes from '@common/store/modules/estimate/types';

import { mapActions as xeronoteMapActions } from '@common/store/modules/xeronote';
import * as xeronoteTypes from '@common/store/modules/xeronote/types';
import { sleep, nativeDeviceInfo } from '@common/lib/common/utils';

import {
  mapActions as shopMapActions,
  mapState as shopMapState,
  mapGetters as shopMapGetters,
} from '@common/store/modules/shop';
import * as shopTypes from '@common/store/modules/shop/types';

export default {
  name: 'EstimationForm',
  data() {
    return {
      create_estimation: '',
      myDeviceName: '테스트',
      myTelecomName: '테스트',
      modal: false,
      isCorrectRegisteredPhone: '',
      estimationTarget: {
        name: '',
        value: '',
      },
      estimationTargetAge: {},
      needModelName: '',
      estimationTelecomMaintance: {},
      telecomMaintanceName: '',
      estimationDataUsage: {},
      dataUsageName: '',
      estimationModelInternetUsage: {},
      telecomList: {
        content: [
          { telecom_id: 'SKT', telecom_name: 'SKT' },
          { telecom_id: 'KT', telecom_name: 'KT' },
          { telecom_id: 'LGUPLUS', telecom_name: 'LGU+' },
          { telecom_id: 'MMOBILE', telecom_name: '알뜰폰' },
          { telecom_id: 'NONE', telecom_name: '사용안함' },
        ],
      },
    };
  },
  async created() {
    if (
      !(
        this.estimationModel.steps === 5 ||
        this.estimationModel.steps === 6 ||
        this.estimationModel.steps === 7
      )
    ) {
      this.resetEstimationModel();
      this.estimationModel.telecomId = '';
      if (this.estimationModel.needDeviceIdx) {
        this.needModelName = this.estimationModel.needModelName;
      }
      this.estimationModel.needModelName = '';
    } else {
      this.estimationModel.telecomId = this.telecomList.content[0].telecom_id;
      if (this.estimationModel.needDeviceIdx) {
        this.needModelName = this.estimationModel.needModelName;
      }

      if (this.needModelName === '') {
        this.estimationModel.needModelName = '';
      }
    }
    await this[userTypes.FETCH_ME]();
    await this.getDevice();
    await this.getShops();
  },
  computed: {
    ...userMapGetters({
      user: userTypes.USER,
    }),
    ...shopMapGetters({
      shops: shopTypes.SHOPS,
      shopInfo: shopTypes.SHOP,
      shopCnt: shopTypes.SHOP_COUNT,
    }),
    ...estimateMapGetters({
      estimationModel: estimateTypes.ESTIMATION_MODEL,
    }),
    ...commonMapGetters({
      appInfo: commonGetters.APPINFO,
    }),
    concatTargetName: function() {
      return this.estimationModel.targetAgeName
        ? this.estimationModel.targetName +
            ' / ' +
            this.estimationModel.targetAgeName
        : this.estimationModel.targetName;
    },
    concatTelecomAndDeviceName: function() {
      return this.estimationModel.currentModelName
        ? this.estimationModel.telecomName +
            ' / ' +
            this.estimationModel.currentModelName
        : this.estimationModel.telecomName;
    },
  },
  methods: {
    ...userMapActions([userTypes.FETCH_ME, userTypes.FETCH_USER_DEVICE]),
    ...shopMapActions([shopTypes.FETCH_SHOPS]),
    ...commonMapActions([commonActions.SET_DIALOG, commonActions.HIDE_DIALOG]),
    ...xeronoteMapActions([xeronoteTypes.FETCH_TELECOM_LIST]),
    ...estimateMapActions([
      estimateTypes.CREATE_ESTIMATION,
      estimateTypes.SET_ESTIMATION_MODEL,
      estimateTypes.ESTIMATION_MODEL_RESET_STATE,
    ]),
    gotoDeviceList() {
      this[estimateTypes.SET_ESTIMATION_MODEL](this.estimationModel);
      this.$router.push({ name: 'Estimation.DeviceList' });
    },
    resetEstimationModel() {
      this[estimateTypes.ESTIMATION_MODEL_RESET_STATE]();
    },
    showDialogNotValidation() {
      this[commonActions.SET_DIALOG]({
        type: 'normal',
        icon: 'warning',
        //title: this.$t('common.confirm'),
        message: '요청 정보를 선택 하신 후 다음으로 이동이 가능 합니다.',
        okCb: async () => {},
      });
    },
    prevStep() {
      this.estimationModel.steps--;

      if (
        this.estimationModel.target !== 4 &&
        this.estimationModel.steps === 2
      ) {
        this.estimationModel.steps--;
        return false;
      }

      if (
        this.estimationModel.target === 4 &&
        this.estimationModel.steps === 3
      ) {
        this.estimationModel.steps = 2;
        return false;
      }

      if (
        this.estimationModel.target !== 1 &&
        this.estimationModel.steps === 3
      ) {
        this.estimationModel.steps = 1;
        return false;
      }

      if (
        this.isCorrectRegisteredPhone === 'true' &&
        this.estimationModel.steps === 5
      ) {
        this.estimationModel.steps = this.estimationModel.steps - 2;
        return false;
      }

      // 변경하고 싶은 휴대폰은 무엇인가요?
      // if (this.estimationModel.steps === 6) {
      //   if (this.needModelName !== '') {
      //     this.estimationModel.needModelName = this.needModelName;
      //     return false;
      //   } else {
      //     this.estimationModel.needModelName = '';
      //     return false;
      //   }
      // }
    },
    validateNextStep() {
      const steps = this.estimationModel.steps;
      if (steps === 1 && this.estimationTarget.value === '') return false;
      if (steps === 2 && !this.estimationTargetAge.value) return false;
      if (steps === 3 && this.isCorrectRegisteredPhone === '') return false;
      //단말정보 못 읽어온 경우 '예' 선택하면 안됨.
      /*if ( //단말 정보 못 읽어와도 다음 단계 진행(3차 수정 내용 2021-10-20)
        steps === 3 &&
        this.isCorrectRegisteredPhone === 'true' &&
        !this.myTelecomName
      )
        return false;*/

      if (steps === 4 && this.estimationModel.telecomId === '') return false;
      if (steps === 5 && this.estimationModel.currentModelName === '')
        return false;
      if (steps === 6 && this.estimationModel.needModelName === '')
        return false;
      if (steps === 7 && !this.estimationTelecomMaintance.value) return false;
      if (steps === 8 && !this.estimationDataUsage.value) return false;
      if (steps === 9 && !this.estimationModelInternetUsage.value) return false;

      return true;
    },
    nextStep() {
      const validate = this.validateNextStep();
      if (!validate) {
        this.showDialogNotValidation();
        return false;
      }

      console.log('before = ' + this.estimationModel.steps);

      this.estimationModel.steps++;

      console.log('after = ' + this.estimationModel.steps);

      // 어느 분의 휴대폰을 구매하고자 하시나요?
      if (this.estimationModel.steps === 2) {
        this.estimationModel.targetName = this.estimationTarget.name;
        this.estimationModel.target = this.estimationTarget.value;

        if (this.estimationTarget.value === 1) {
          this.estimationModel.steps = 3;
        } else if (this.estimationModel.target !== 4) {
          this.estimationModel.targetAgeName = '';
          this.estimationModel.targetAge = 0;
          this.estimationModel.steps = 4;
        } else {
          this.estimationModel.targetAge = 2;
        }
        return false;
      }

      // 자녀분의 연령대는 어떻게 되나요?
      if (this.estimationModel.steps === 3) {
        if (this.estimationModel.target !== 4) {
          this.estimationModel.targetAgeName = '';
          this.estimationModel.targetAge = '';
        } else {
          this.estimationModel.targetAgeName = this.estimationTargetAge.name;
          this.estimationModel.targetAge = this.estimationTargetAge.value;
        }
        this.estimationModel.steps = 4;
        return false;
      }

      // 현재 사용하시는 핸드폰 정보가 맞나요?
      if (this.estimationModel.steps === 4) {
        if (this.isCorrectRegisteredPhone === 'true') {
          this.estimationModel.currentModelName = this.myDeviceName;
          this.estimationModel.telecomName = this.myTelecomName || '-';
          this.estimationModel.telecomId = this.myTelecomName || '-';
          this.estimationModel.needModelName = '';

          this.estimationModel.steps = this.estimationModel.steps + 2;
        }
        return false;
      }

      // 현재 사용중인 통신사를 선택해주세요
      if (this.estimationModel.steps === 5) {
        this.estimationModel.currentModelName = '';
        this.estimationModel.telecomName = '';

        if (this.estimationModel.telecomId === 'NONE') {
          this.estimationModel.telecomMaintance = 0;
          this.estimationModel.needModelName = ' ';
          this.estimationModel.dataUsage = 0;
          this.estimationModel.internetUsage = 0;

          this.estimationModel.steps = 6;
        }

        this.estimationModel.telecomName = this.telecomList.content.find(
          d => d.telecom_id === this.estimationModel.telecomId,
        ).telecom_name;
        return false;
      }

      // 변경하고 싶은 휴대폰은 무엇인가요?
      if (this.estimationModel.steps === 6) {
        console.log('this.needModelName = ' + this.needModelName);
        if (this.needModelName != '') {
          this.estimationModel.needModelName = this.needModelName;
          return false;
        } else {
          this.estimationModel.needModelName = '';
          return false;
        }
      }

      // 통신사를 유지할 의향
      if (this.estimationModel.steps === 8) {
        this.estimationModel.telecomMaintance = this.estimationTelecomMaintance.value;
        this.telecomMaintanceName = this.estimationTelecomMaintance.name;
        return false;
      }

      // 데이터 사용 용도
      if (this.estimationModel.steps === 9) {
        this.dataUsageName = this.estimationDataUsage.name;
        this.estimationModel.dataUsage = this.estimationDataUsage.value;
        return false;
      }

      if (this.estimationModel.steps === 10) {
        this.estimationModel.internetUsage = this.estimationModelInternetUsage.value;
        // 견적 요청서 저장 API 호출
        this.createEstimation().then(res => {
          console.log(res);
          this.create_estimation = res;

          console.log(this.create_estimation);
          console.log(this.create_estimation.id);
          console.log('shopcnt = ' + this.shopCnt);
          console.log(this.shops.totalElements);

          if (this.shops.totalElements > 0) {
            this.$router.push({
              name: 'Shops.listsend',
              query: { estimateId: this.create_estimation.id },
            });
          } else {
            this[estimateTypes.SET_ESTIMATION_MODEL](this.estimationModel);
            this.$router.push({ name: 'Estimation.Complete' });
          }
          return false;
        });
      }
    },
    async getShops() {
      const params = {
        page: 1,
        size: 10,
      };
      await this[shopTypes.FETCH_SHOPS](params);
    },
    async createEstimation() {
      const data = await this[estimateTypes.CREATE_ESTIMATION](
        this.estimationModel,
      );
      return data;
    },
    async getDevice() {
      nativeDeviceInfo();
      await sleep(500);
      // this.myDeviceName = window.$bridge.deviceModelName || '-';

      this.myDeviceName = await this[userTypes.FETCH_USER_DEVICE]({
        id: this.user.id,
      });

      if (this.myDeviceName != '-') {
        const modelName = this.myDeviceName.split('의 ');
        console.log(modelName);
        this.myDeviceName =
          modelName.length == 1 ? this.myDeviceName : modelName[1];
      }

      this.myDeviceName = this.myDeviceName || '-';
      this.myTelecomName = window.$bridge.telecomName || '-';
    },
    showDetailView() {
      var someElement = document.getElementById(`detailView`);
      someElement.classList.toggle('on');
    },
  },
};
</script>
